"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = exports.StyledExclamationIcon = exports.StyledArrowIcon = exports.Span = exports.Label = exports.Container = exports.Wrapper = exports.StyledSelect = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.StyledSelect = styled_components_1.default.select `
  color: #000;
  width: 100%;
  height: 75px;
  outline: none;
  font-size: 15px;
  padding: 20px 25px;
  border-radius: 6px;
  position: relative;
  background: url(${process.env.PUBLIC_URL + '/images/arrow_down.png'})
    no-repeat;
  background-position: 95% center;
  border: ${({ invalid }) => invalid ? `2px solid #E33610` : `0.5px solid #b7bec6`};
  appearance: none;
  text-indent: 1px;

  &:not(:checked) {
    padding-top: 30px;
  }

  &:not(:checked) + label {
    transform: translateY(-20px);
    font-size: 12px;
  }

  &:focus {
    padding-top: 30px;
  }

  &:focus + label {
    transform: translateY(-20px);
    font-size: 12px;
  }
`;
exports.Wrapper = styled_components_1.default.div `
  width: 100%;
  position: relative;
  display: inline-block;
`;
exports.Container = styled_components_1.default.div `
  gap: 12px;
  display: flex;
  flex-direction: column;
`;
exports.Label = styled_components_1.default.label `
  top: 50%;
  left: 25px;
  color: #9fa8b3;
  font-size: 15px;
  font-weight: 500;
  position: absolute;
  pointer-events: none;
  transform: translateY(-50%);
  transition: transform 100ms ease;
`;
exports.Span = styled_components_1.default.span `
  color: #e12900;
  font-size: 15px;
  font-weight: 500;
`;
exports.StyledArrowIcon = (0, styled_components_1.default)(__1.Icon) `
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
`;
exports.StyledExclamationIcon = (0, styled_components_1.default)(__1.Icon) `
  position: absolute;
  right: 48px;
  top: 50%;
  transform: translateY(-50%);
`;
exports.Option = styled_components_1.default.option ``;
